import { GetterTree } from "vuex";
import { CATEGORIAS } from "./types";
import { RootState } from "@/store/modules/general/types";

type CategoriasTree = GetterTree<CATEGORIAS, RootState>;

export const getters: CategoriasTree = {
  
};
